module.exports = {
    licence:{
        Robot_problem_solved:'已解決',
        Robot_problem_unsolved:'未解決',
        Robot_emptyMassege_reminder:"不能發送空消息",
        Robot_massege_ViewMore:'查看全部',
        Robot_massege_ViewLess:'收起',
        Robot_greetings_1:'你好，我能為你做什麼？',
        Robot_greetings_2:'試著輸入關鍵詞找答案吧。',
        Robot_closing_1_1:'噢，抱歉！我還在學習中。',
        Robot_closing_1_2:"請嘗試使用其他關鍵字，或直接單擊",
        Robot_closing_1_login_1:'噢，抱歉！ 我还在学习中。',
        Robot_closing_1_login_2:'请尝试使用其他关键字！',
        Robot_closing_2:'這裡 ',
        Robot_closing_3:'聯繫人工客服，我們會盡快回复您',
        Robot_closing:'這個問題我還不太確定，點擊聯繫人工客服，我們會盡快回复您',
        Robot_problem_unsolved_reply:'抱歉沒有幫助到您，點擊這里聯係人工客服，我們會盡快聯繫您',
        Robot_TypeHere:'在這裡輸入',
        Robot_greetings_label1:'將數據合併到新的應用程序中',
        Robot_greetings_label2:'移轉後資料遺失',
        Robot_greetings_label3:'秤在遷移後斷開連接',
        Robot_greetings_label4:'遷移後的小貼士',
        Robot_greetings_label5:'顯示在卡片中的圖形',
        Robot_greetings_label6:'查看過往體重記錄',
        Robot_greetings_label7:'查看過往體圍記錄',
        Robot_greetings_label8:'如何獲得幫助',
        Robot_greetings_label9:'其他問題',
        key_internet_error:'網絡異常，請檢查網絡設置',
        Robot_title_Beta:'聊天機器人',
        Robot_greetings_label1_login:'忘記密碼',
        Robot_greetings_label2_login:'如何重置密碼',
        Robot_greetings_label3_login:'將數據合併到新的應用程序中',
        Robot_greetings_label4_login:'為何有兩個應用程式',
        Robot_greetings_label5_login:'帳戶登入注意事項',
        Robot_greetings_label6_login:"是否需要在新應用程式重新註册",
        Robot_greetings_label7_login:"我在兩個應用程式上均有帳戶，該如何處理",
        Robot_greetings_label8_login:'如何獲得幫助',
        Robot_greetings_label9_login:'其他',
        Robot_greetings_label1_devicePage:'添加設備的方法',
        Robot_greetings_label2_devicePage:'透過「添加設備彈出視窗」添加設備',
        Robot_greetings_label3_devicePage:'手動添加設備',
        Robot_greetings_label4_devicePage:'配對Wifi藍牙磅秤的小貼士',
        Robot_greetings_label5_devicePage:'如何配對Wifi',
        Robot_greetings_label6_devicePage:"設備並未列於「已配對設備」下",
        Robot_greetings_label7_devicePage:"删除設備",
        Robot_greetings_label8_devicePage:'如何獲得幫助',
        Robot_greetings_label9_devicePage:'其他',
        Robot_greetings_label1_mePage:'我可以更改主用戶嗎',
        Robot_greetings_label2_mePage:'如何編輯主用戶的資料',
        Robot_greetings_label3_mePage:'查看好友的數據',
        Robot_greetings_label4_mePage:'添加好友',
        Robot_greetings_label5_mePage:'如何發送好友請求',
        Robot_greetings_label6_mePage:"如何查看朋友請求",
        Robot_greetings_label7_mePage:"删除朋友",
        Robot_greetings_label8_mePage:'如何獲得幫助',
        Robot_greetings_label9_mePage:'其他',
        Robot_greetings_label1_balancePage:'體重數據不同步到APP',
        Robot_greetings_label2_balancePage:'如何檢查藍牙錯誤',
        Robot_greetings_label3_balancePage:'應用程式僅顯示體重和BMI',
        Robot_greetings_label4_balancePage:'肌肉讀數顯示為「--」',
        Robot_greetings_label5_balancePage:'磅秤稱重不正確',
        Robot_greetings_label6_balancePage:"體脂百分比讀數出現重大改變",
        Robot_greetings_label7_balancePage:"手動輸入體重數據",
        Robot_greetings_label8_balancePage:'切換到另一個測量使用者',
        Robot_greetings_label9_balancePage:'其他',
        Robot_greetings_label1_tapPage:'如何使用卷尺',
        Robot_greetings_label2_tapPage:'切換到另一測量用戶',
        Robot_greetings_label3_tapPage:'查看體圍趨勢圖表',
        Robot_greetings_label4_tapPage:'查看過往體圍記錄',
        Robot_greetings_label5_tapPage:'手動輸入體圍數據',
        Robot_greetings_label6_tapPage:"如何獲得幫助",
        Robot_greetings_label7_tapPage:"其他",
        savetoAlbum: "已儲存到相册",
        key_cancel: '取消',
        key_confirm: '確定',
        key_deleted: '已成功删除',
        key_delete_popup: '歷史記錄删除後將無法恢復，您確認要刪除嗎?',
        key_delete_history: '删除聊天記錄',
        key_delete_confirmation: '删除確認'
    }
}